import { API_BASE, ROUTER_BASENAME } from '../config'

/** Gateway root without trailing /api (serves /assets/uploads/…). */
function uploadsRoot() {
  return String(API_BASE || '')
    .replace(/\/api\/?$/, '')
    .replace(/\/$/, '')
}

/**
 * Public static files under the React app (assets/images/…).
 * Always prefixes ROUTER_BASENAME so relative page URLs (e.g. /arihant_trust
 * without a trailing slash) do not resolve to /assets/… at the host root.
 */
export function staticAssetUrl(path) {
  const base = (ROUTER_BASENAME || '').replace(/\/$/, '')
  const clean = String(path || '').replace(/^\//, '')
  if (!clean) return base || ''
  return `${base}/${clean}`
}

/**
 * Resolve DB/API image paths for <img src>.
 * Handles absolute prod URLs, gateway-relative assets/, and legacy upload/ paths.
 * Returns '' when path is empty/unusable.
 */
export function mediaUrl(path) {
  if (path == null || path === '') return ''
  const s = String(path).trim()
  if (!s) return ''

  if (/^blob:|^data:/i.test(s)) return s

  if (/^https?:\/\//i.test(s)) {
    try {
      const u = new URL(s)
      const m = u.pathname.match(/\/(assets\/uploads\/.+)$/i)
      if (m) return `${uploadsRoot()}/${m[1]}`
    } catch (e) {
      /* keep original */
    }
    return s
  }

  if (s.startsWith('/arihant_trust/') || s.startsWith(ROUTER_BASENAME + '/')) {
    return s
  }

  if (s.startsWith('/assets/')) {
    return `${(ROUTER_BASENAME || '').replace(/\/$/, '')}${s}`
  }

  const clean = s.replace(/^\//, '')

  if (clean.startsWith('assets/')) {
    return `${uploadsRoot()}/${clean}`
  }

  if (clean.startsWith('upload/')) {
    return `${uploadsRoot()}/assets/uploads/ProfileImages/${clean.slice('upload/'.length)}`
  }

  return `${uploadsRoot()}/assets/uploads/ProfileImages/${clean}`
}

/** Hide broken <img> (missing file) without showing the browser broken-icon. */
export function hideBrokenImg(e) {
  const el = e?.currentTarget || e?.target
  if (!el) return
  el.onerror = null
  el.style.display = 'none'
  el.removeAttribute('src')
}
